const faqItems = [
  {
    q: '羞羞歪歪漫画需要注册才能看吗？',
    a: '不需要注册！羞羞歪歪漫画全集免费阅读，在线看入口免费直达，无需任何注册登录即可畅读全部章节无删减内容。',
  },
  {
    q: '羞羞歪歪漫画的全部章节是否真的无删减？',
    a: '是的，羞羞歪歪漫画承诺全部章节完整呈现，不做任何删减处理。我们尊重原作的完整性，确保每一位读者都能看到原汁原味的漫画内容。',
  },
  {
    q: '羞羞歪歪漫画下拉式竖屏阅读如何操作？',
    a: '下拉式竖屏阅读是羞羞歪歪漫画的特色功能。在移动端或网页端打开漫画后，只需向下滑动屏幕即可连续阅读，无需点击翻页按钮，还原纸质漫画般的沉浸式阅读体验。',
  },
  {
    q: '羞羞歪歪漫画的更新频率是怎样的？',
    a: '羞羞歪歪漫画每日同步更新热门连载作品最新章节，确保您能在第一时间追到最新内容。具体每部作品的更新周期以作品页面显示为准。',
  },
  {
    q: '羞羞歪歪漫画有移动端APP吗？',
    a: '有的！羞羞歪歪漫画提供iOS和Android客户端下载，专为竖屏阅读优化，支持离线缓存功能。您可以在本页面的APP下载区域找到下载入口。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          常见问题
        </h2>
        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary-100 flex items-center justify-center mt-0.5">
                    <span className="text-xs font-medium text-primary-600">Q</span>
                  </span>
                  <div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">
                      {item.q}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}